<template>
	<div class="container__menu">
		<MenuOptions />
		<div
			id="app"
			class="container__menu__lang"
		>
			<LanguageSelector />
		</div>

		<MenuUserNotifications />
	</div>
</template>

<script>
import MenuOptions from './MenuOptions/MenuOptions'
import MenuUserNotifications from './MenuUserNotifications/MenuUserNotifications'
import LanguageSelector from '../LanguageSelector/LanguageSelector.vue'

export default {
	components: { MenuOptions, MenuUserNotifications, LanguageSelector },

	methods: {
		mudarIdioma() {
			const idioma = this.$i18n.locale === 'ptbr' ? 'es' : 'ptbr'
			localStorage.setItem('idioma', idioma)
			this.$i18n.locale = idioma
		},
	},
}
</script>

<style scoped>
.container__menu {
	width: 100%;
	max-width: 1400px;
	margin: 0 auto;
	height: fit-content;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
	padding: 0 2rem;
}

@media screen and (min-width: 1400px) {
	.container__menu {
		padding: 0;
	}
}

/* menu com tamanho de conteúdo (não cresce) e pode encolher, sem empurrar os ícones para fora */
.container__menu > .container__menuoptions {
	flex: 0 1 auto;
	min-width: 0;
	width: auto;
}

/* globo e bloco do usuário (sino + avatar) nunca colapsam nem somem */
.container__menu__lang,
.container__menu > .container__menuuser {
	flex-shrink: 0;
}

.container__globe__icon {
	cursor: pointer;
}
</style>
